import script from "./ImageReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageReportView.vue?vue&type=script&setup=true&lang=js"

import "./ImageReportView.vue?vue&type=style&index=0&id=74e6385f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e6385f"]])

export default __exports__